import React from "react"

const Centered = (props) => (
    <div {...props} className={`${props.className} d-flex flex-column align-items-center justify-content-center text-center`}>
        {props.children}
    </div>
)

export default Centered


// WEBPACK FOOTER //
// ./src/components/simple/Centered/index.js